window.__istt_debug_asset_loaded = true;

(function() {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    document.querySelectorAll('[data-istt-countdown]').forEach(function(el) {
      var target = new Date(el.dataset.target).getTime();
      var now = Date.now();
      var s = Math.max(0, Math.floor((target - now) / 1000));
      var days = Math.floor(s / 86400);
      var hours = Math.floor((s % 86400) / 3600);
      var mins = Math.floor((s % 3600) / 60);
      var secs = s % 60;
      var vals = { days: pad(days), hours: pad(hours), mins: pad(mins), secs: pad(secs) };
      el.querySelectorAll('[data-cd]').forEach(function(span) {
        span.textContent = vals[span.dataset.cd];
      });
    });
  }
  tick();
  setInterval(tick, 1000);
})();